<template>
  <div class="container-00">
    <div class="osc-block-00 osc-border-00 card-00">
      <div class="card-title-00">
        {{ parameter_group_title }} &nbsp;
        <v-btn x-small icon v-on:click="dump_noisegen_param()"><v-icon>mdi-text-box-outline</v-icon></v-btn>
      </div>

      <!-- --------------------- -->
      <div class="knob-block-00">
        <div class="knob-00-parent">
          <div class="knob-00-child-00 justify-align-center">
            <div class="knob-label-00"><div>TIME</div></div>
            <div class="knob-ctrl-00"><webaudio-knob id="knob-0" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="noisegen_param.noiseTime" v-on:change="onUpdateParam('noiseTime', $event.target.value)" conv="Math.round(100 * x / 127)" tooltip="Time<br/>%d %"></webaudio-knob></div>
          </div>
        </div>
        <div class="knob-00-parent">
          <div class="knob-00-child-00">
            <div class="knob-label-00 justify-align-center">BREATH</div>
            <div class="knob-ctrl-00"><webaudio-knob id="knob-2" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="noisegen_param.noiseBreath" v-on:change="onUpdateParam('noiseBreath', $event.target.value)" conv="const val=Math.round(100 * x / 127)-50; (val>0) ? '+' + val : val" tooltip="Breath Amount<br/>%s %"></webaudio-knob></div>
          </div>
        </div>
      </div>

      <!-- --------------------- -->
      <div class="slider-block-00">
        <div class="slider-00-child-00">
          <div class="slider-label-00 justify-align-center">LEVEL</div>
          <div class="slider-ctrl-00"><webaudio-slider width="20" id="slider10" direction="vert" colors="#fff;#444;#fff" min="0" max="127" :value="noisegen_param.noiseLevel" v-on:change="onUpdateParam('noiseLevel', $event.target.value)" conv="Math.round(100 * x / 127)" tooltip="Level<br/>%d %"></webaudio-slider></div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  export default {
  name: 'Noisegen',
   props: ['parameter_group_title', 'label', 'noisegenparam'],
   methods: {
     dump_noisegen_param: function() {
       const workingPatch_idx = this.$store.getters.getWorkingPatchIdx()
       const workingPatch = this.$store.getters.getOneEditPatch(workingPatch_idx)
       console.log(`[store:${this.label}]`, workingPatch.decoded)
       console.log(`[local:${this.label}]`, this.$data.noisegen_param)
       //console.log(`[${this.label}]`, this.$data.noisegen_param)
     },
     onUpdateParam: function(key, val) {
       //const workingPatch_idx = this.$store.getters.getWorkingPatchIdx()
       //const workingPatch = this.$store.getters.getOneEditPatch(workingPatch_idx)
       //console.log(this.noisegen_param, key, val, this.label, this.$data, workingPatch)
       this.$set(this.$data.noisegen_param, key, val)
       this.$store.commit('onEditOneEditPatch', {arr_idx: [key], value: Uint8Array.from([val])})

       // let PatchNumNameCard component to recognise params change
       this.$router.app.$children[0].updateParamIsSyncedApp()
     }
   },
   created: function() {
     console.log(`<CREATED> label=[${this.label}]`)
     Object.keys(this.noisegenparam).forEach( key => {
       this.$data.noisegen_param[key] = this.noisegenparam[key]
     })
   },
   computed: {
     testCount: {
       get () {
         return this.$store.getters.getTestCount()
       },
       //set (value) {
       //this.$store.commit('onTestChange', value)
       //}
     }
   },
   data: () => ({
     noisegen_param: {
       noiseTime: 0,
       noiseBreath: 0,
       noiseLevel: 0
     }
   })
 }
</script>
